module.exports = __webpack_public_path__ + "static/media/trash.93becc84.svg";